<div>
    <dx-data-grid
        bds-grid
        id="bdsReportGrid"
        [dataSource]="gridSource"
        height="80vh"
        minHeight="200px"
        [allowColumnResizing]="true"
        [columnAutoWidth]="true"
        [showBorders]="true"
    >
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

        <dxi-column dataField="car_init" caption="Car Init"></dxi-column>
        <dxi-column dataField="car_no" caption="Car No."></dxi-column>
        <dxi-column
            dataField="ship_date_time"
            caption="Ship Date"
            format="MM/dd/yy HH:mm"
            dataType="datetime"
        ></dxi-column>
        <dxi-column dataField="cust_no" caption="Cust No."></dxi-column>
        <dxi-column dataField="fleet_id" caption="Fleet"></dxi-column>
        <dxi-column dataField="business_group" caption="Business Group"></dxi-column>
        <dxi-column dataField="car_status" caption="Car Status"></dxi-column>
        <dxi-column dataField="trip_status" caption="Trip Status"></dxi-column>
        <dxi-column dataField="car_condition" caption="Condition"></dxi-column>
        <dxi-column dataField="return_city" caption="Return City"></dxi-column>
        <dxi-column dataField="return_state" caption="St"></dxi-column>
        <dxi-column dataField="dest_city" caption="Destination"></dxi-column>
        <dxi-column dataField="dest_state" caption="St"></dxi-column>
        <dxi-column dataField="last_comm_code" caption="Last Comm"></dxi-column>
        <dxi-column dataField="comm_short_name" caption="Comm Name"></dxi-column>
        <dxi-column dataField="car_class" caption="Car Class"></dxi-column>
        <dxi-column dataField="capacity" caption="Capacity"></dxi-column>
        <dxi-column dataField="insulated" caption="Insulated"></dxi-column>
        <dxi-column dataField="no_compart" caption="No. Compart"></dxi-column>
        <dxi-column dataField="coils_type" caption="Coils Type"></dxi-column>
        <dxi-column dataField="lining_ind" caption="Lining"></dxi-column>
        <dxi-column dataField="gauge_device_type" caption="Gauge Device"></dxi-column>
        <dxi-column dataField="unload_top_type" caption="Unload Top"></dxi-column>
        <dxi-column dataField="unload_bot_type" caption="Unload Bottom"></dxi-column>
        <dxi-column dataField="eduction_type" caption="Eduction"></dxi-column>
        <dxi-column dataField="facilitator_yorn" caption="Facilitator"></dxi-column>
        <dxi-column dataField="vac_rel_yorn" caption="Vac Rel"></dxi-column>
        <dxi-column dataField="car_mile_rate" caption="Mile Rate"></dxi-column>
        <dxi-column
            dataField="tank_test_due"
            caption="Tank Test Due"
            format="MM/dd/yy"
            dataType="date"
        ></dxi-column>
        <dxi-column
            dataField="valve_test_due"
            caption="Valve Test Due"
            format="MM/dd/yy"
            dataType="date"
        ></dxi-column>
        <dxi-column
            dataField="coil_test_due"
            caption="Coil Test Due"
            format="MM/dd/yy"
            dataType="date"
        ></dxi-column>
        <dxi-column
            dataField="next_maint_date"
            caption="Next Maint"
            format="MM/dd/yy"
            dataType="date"
        ></dxi-column>
        <dxi-column
            dataField="lining_test_date_due"
            caption="Lining Test Due"
            format="MM/dd/yy"
            dataType="date"
        ></dxi-column>
        <dxi-column
            dataField="paint_due"
            caption="Paint Due"
            format="MM/dd/yy"
            dataType="date"
        ></dxi-column>
        <dxi-column
            dataField="stub_sill_test_date"
            caption="Stub Sill Test"
            format="MM/dd/yy"
            dataType="date"
        ></dxi-column>
        <dxi-column
            dataField="spark_test_due"
            caption="Spark Test Due"
            format="MM/dd/yy"
            dataType="date"
        ></dxi-column>
        <dxi-column
            dataField="test_88b2_inspection_date_due"
            caption="88B2 Insp Due"
            format="MM/dd/yy"
            dataType="date"
        ></dxi-column>
        <dxi-column
            dataField="shell_thickness_due_date"
            caption="Shell Thick Due"
            format="MM/dd/yy"
            dataType="date"
        ></dxi-column>
        <dxi-column dataField="loc_city" caption="Location"></dxi-column>
        <dxi-column dataField="loc_state" caption="St"></dxi-column>
        <dxi-column dataField="sight_code" caption="Code"></dxi-column>
        <dxi-column
            dataField="clm_date_time"
            caption="CLM Date"
            format="MM/dd/yy HH:mm"
            dataType="datetime"
        ></dxi-column>
        <dxi-column dataField="le" caption="L/E"></dxi-column>
        <dxi-column dataField="road" caption="Road"></dxi-column>
        <dxi-column dataField="trn_jct" caption="Train/Jct"></dxi-column>
        <dxi-column dataField="hot_list_flag" caption="Hot List"></dxi-column>
        <dxi-column dataField="hot_list_flag_mech" caption="HL Mech"></dxi-column>
        <dxi-column dataField="hot_list_flag_leas" caption="HL Leas"></dxi-column>
        <dxi-column dataField="free_runner" caption="Free Runner"></dxi-column>
        <dxi-column dataField="trouble_yorn" caption="Trouble"></dxi-column>
        <dxi-column dataField="COMMENTS" caption="Comments"></dxi-column>
        <dxi-column dataField="ecomment_code" caption="Expeditor Comment"></dxi-column>
        <dxo-summary>
            <dxi-total-item
                summaryType="count"
                displayFormat="Total Count: {0}"
                alignment="right"
            ></dxi-total-item>
        </dxo-summary>
    </dx-data-grid>
</div>
